import {AppBar, Container, Icon, Stack, Switch, Toolbar, Typography} from "@mui/material";
import {useThemeContext} from "../context/ThemeContext";

export default function Header() {
    const {toggleTheme} = useThemeContext();

    const handleToggleTheme = () => {
        toggleTheme();
    }

    return (
        <AppBar>
            <Container sx={{height: '100%'}}>
                <Toolbar sx={{gap: 2}}>
                    <Stack>
                        <img width={66} height={80} style={{margin: 'auto'}}
                             src="https://persiansaze.com/wp-content/uploads/2025/01/persiansaze-logo-new.png"
                             alt="پرشین سازه"/>
                        <Typography component="h1" fontSize="large">پرشین سازه</Typography>
                    </Stack>

                    <span style={{flex: 1}}></span>


                    <Stack direction='row' alignItems='center'>
                        <Icon>light_mode</Icon>
                        <Switch onChange={handleToggleTheme}></Switch>
                        <Icon>brightness_4</Icon>
                    </Stack>
                </Toolbar>
            </Container>
        </AppBar>
    );
}
